import type { CSSProperties } from 'react'
import type { CircleColor } from '../../shared/circleColors'
import { useFamilies } from './families'
import { useFrame } from './frame'

// The colour of the circle you're in, or none on a page that isn't in one.
export function useCircleColor(): CircleColor | null {
  const { familyId } = useFrame()
  const families = useFamilies().data?.families
  return families?.find((x) => x.id === familyId)?.color ?? null
}

// Sets --circle (styles/circle-ring.css) to a circle's colour, for whatever is drawn in it.
export const circleStyle = (color: CircleColor) => ({ '--circle': `var(--circle-${color})` }) as CSSProperties
